<template>
  <div class="login-box">
    <el-dialog
      title
      :visible.sync="loginDialogVisible"
      :append-to-body="true"
      :modal-append-to-body="true"
      :close-on-click-modal="false"
      width="380px"
      custom-class="login-dailog"
      @close="entryFormInfo"
    >
      <div class="title_box" v-if="website.is_open_register">
        <div class="sliding" :class="isLogin ? 'l1' : 'l2'"></div>
        <span class="title" @click="changeSliding(true)">登录</span>
        <span class="title" @click="changeSliding(false)">注册</span>
      </div>
      <div class="title_box" v-else>
        <span class="title">登录</span>
      </div>

      <!-- 登录 -->
      <el-form
        v-show="isLogin"
        :model="loginValidate"
        ref="loginValidate"
        :rules="rules"
        class="login-form tc"
        @submit.native.prevent
      >
        <el-form-item prop="phone">
          <el-input
            v-model.trim="loginValidate.phone"
            placeholder="请输入手机号或账号"
            ref="phoneInput"
            @focus="lFocus('phone')"
            @blur="lBlur('phoneInput', 'phone')"
            @keyup.enter.native="phoneLogin('loginValidate')"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="pass"
          class="password-item"
          style="position: relative"
        >
          <el-input
            :type="passType"
            v-model.trim="loginValidate.pass"
            autocomplete="off"
            placeholder="请输入密码"
            maxlength="16"
            ref="passInput"
            @focus="lFocus('pass')"
            @blur="lBlur('passInput', 'pass')"
            @keyup.enter.native="phoneLogin('loginValidate')"
          ></el-input>
          <i
            class="el-icon-view eyeicon"
            @click="showPwd"
            :class="passType === 'password' ? '' : 'activeEye'"
          />
        </el-form-item>

        <el-form-item
          prop="captcha"
          style="position: relative"
          v-if="isCkeyCode"
        >
          <el-input
            ref="ckey"
            v-model="loginValidate.captcha"
            placeholder="验证码"
            name="ckey"
            type="text"
            tabindex="1"
            autocomplete="on"
            class="ckey"
          />
          <div class="ckeyCodeWrap">
            <img
              :src="ckeyCode"
              class="ckeyCode"
              @click="updateCkeyCode"
              title="更新验证码"
            />
          </div>
        </el-form-item>

        <el-button
          type="primary"
          class="login-btn"
          :loading="loginLoading"
          @click="phoneLogin('loginValidate')"
          >登录</el-button
        >
        <div class="tr">
          <span class="cp tr forgot-btn" @click="openResetPasswordDialog"
            >忘记密码 ?</span
          >
        </div>
      </el-form>
      <!-- 注册 -->
      <el-form
        v-if="!isLogin"
        :model="register"
        ref="register"
        :rules="rules2"
        class="login-form tc reg-form"
        @submit.native.prevent
      >
        <el-form-item prop="mobile">
          <el-input
            v-model.trim="register.mobile"
            placeholder="请输入您的手机号"
          >
            <img
              src="@/assets/image/reg_mobile.png"
              slot="prefix"
              class="register_img"
            />
          </el-input>
        </el-form-item>
        <el-form-item prop="name">
          <el-input v-model.trim="register.name" placeholder="请输入您的姓名">
            <img
              src="@/assets/image/reg_name.png"
              slot="prefix"
              class="register_img"
            />
          </el-input>
        </el-form-item>

        <el-form-item prop="captcha" style="position: relative">
          <el-input
            ref="ckey"
            v-model="register.captcha"
            placeholder="请输入图形验证码"
            name="ckey"
            type="text"
            tabindex="1"
            autocomplete="on"
            class="ckey"
          >
            <img
              src="@/assets/image/reg_captcha.png"
              slot="prefix"
              class="register_img"
            />
          </el-input>
          <div class="reg_ckey_code">
            <img
              :src="registerCkeyCode"
              class="ckeyCode"
              @click="upRegisterCkeyCode"
              title="更新图形验证码"
            />
          </div>
        </el-form-item>
        <el-form-item prop="code">
          <span class="mobile_ckey_box">
            <el-input
              ref="code"
              v-model="register.code"
              placeholder="请输入验证码"
              name="code"
              type="text"
              tabindex="1"
              autocomplete="on"
              class="mobile_ckey"
            >
              <img
                src="@/assets/image/reg_code.png"
                slot="prefix"
                class="register_img"
              />
            </el-input>
            <div @click="getRegCode" class="mobile_ckey_btn">
              {{ codeName }}
            </div>
          </span>
        </el-form-item>
        <el-form-item prop="password" style="position: relative">
          <el-input
            :type="passType"
            v-model.trim="register.password"
            autocomplete="off"
            placeholder="请输入您的密码"
            maxlength="16"
            ref="passInput"
            @keyup.enter.native="phoneReg('register')"
          >
            <img
              src="@/assets/image/reg_password.png"
              slot="prefix"
              class="register_img"
            />
          </el-input>
          <i
            class="el-icon-view eyeicon"
            @click="showPwd"
            :class="passType === 'password' ? '' : 'activeEye'"
          />
        </el-form-item>
        <el-form-item prop="grade_id" v-if="website.is_show_grade">
          <el-select
            v-model="register.grade_id"
            placeholder="请选择您的班级"
            style="width: 100%"
            filterable
            clearable
          >
            <img
              src="@/assets/image/reg_class.png"
              slot="prefix"
              class="register_img"
            />
            <el-option
              v-for="item in gradesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-button
          type="primary"
          class="login-btn"
          :loading="loginLoading"
          @click="phoneReg('register')"
          >注册</el-button
        >
        <el-checkbox class="consent" v-model="regChecked">
          <span class="consent_box">
            同意 翼狐云课堂
            <span class="premise" @click="goPremise(1)">《服务协议》</span
            >和<span @click="goPremise(0)" class="premise">《隐私政策》</span>
          </span>
        </el-checkbox>
      </el-form>
      <transition name="el-fade-in-linear">
        <div v-show="tipsShow" class="reg_tips">
          您需要同意翼狐设计学习库服务协议才可以注册
        </div>
      </transition>
    </el-dialog>
  </div>
</template>
<script>
import {
  getLoginCkey,
  getIsCode,
  userRegister,
  getLoginCode,
  getGrades,
} from "@/api/header";
import { mapGetters } from "vuex";
export default {
  name: "login",
  data() {
    return {
      isLogin: true,
      isCkeyCode: false,
      ckeyCode: "../../assets/image/login/1.jpg",
      registerCkeyCode: "",
      loginDialogVisible: false, //登录弹窗显示隐藏
      loginValidate: {
        phone: "",
        pass: "",
        ckey: "",
        captcha: "",
      },
      register: {
        mobile: "", // 注册手机号码
        name: "", // 注册姓名
        code: "", // 注册手机验证码
        ckey: "",
        captcha: "", // 注册图形验证码
        password: "", // 注册密码
        grade_id: undefined, // 注册班级id
      },
      passType: "password",
      rules: {
        phone: [
          { required: true, message: "请输入手机号或账号", trigger: "blur" },
        ],
        pass: [
          {
            required: true,
            message: "请输入密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "请输入6-16位的密码",
            trigger: "blur",
          },
          {
            pattern: /^([0-9]|[a-zA-Z]|(?=[\x21-\x7e]+)[^A-Za-z0-9]){6,16}$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        captcha: [{ required: true, trigger: "blur", message: "请输入验证码" }],
      },
      rules2: {
        mobile: [
          { required: true, message: "请输入您的手机号", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
            message: "请输入正确的手机号码",
            trigger: "blur",
          },
        ],
        name: [{ required: true, trigger: "blur", message: "请输入您的姓名" }],
        password: [
          {
            required: true,
            message: "请输入您的密码",
            trigger: "blur",
          },
          {
            min: 6,
            max: 16,
            message: "请输入6-16位的密码",
            trigger: "blur",
          },
          {
            pattern: /^([0-9]|[a-zA-Z]|(?=[\x21-\x7e]+)[^A-Za-z0-9]){6,16}$/,
            message: "密码格式不正确",
            trigger: "blur",
          },
        ],
        captcha: [
          { required: true, trigger: "blur", message: "请输入图形验证码" },
        ],
        code: [{ required: true, trigger: "blur", message: "请输入验证码" }],
        grade_id: [
          {
            required: true,
            message: "请选择注册班级",
            trigger: "change",
          },
        ],
      },
      regChecked: false,
      tipsShow: false,
      loginLoading: false, //按钮在请求接口过程的loading状态
      codeName: "获取验证码",
      codeDisabled: false,
      CountDown: 60,
      options: [],
    };
  },
  methods: {
    // 显示登陆弹窗
    showLoginDialog() {
      this.loginDialogVisible = true;
    },
    // 显示重置密码弹窗
    openResetPasswordDialog() {
      this.loginDialogVisible = false;
      this.$refs["loginValidate"].resetFields();
      // document.getElementsByClassName('header')[0].style.paddingRight = '0'
      // 关闭第一个dailog后打开新的dailog页面会抖动，因为body的类不见了（设置setTimeout300ms是为了解决页面抖动，淡入淡出动画时间为300ms）
      setTimeout(() => {
        eventBus.$emit("showResetPassword", {
          called: this.called,
        });
      }, 300);
    },
    // 显示密码
    showPwd() {
      if (this.passType === "password") {
        this.passType = "";
      } else {
        this.passType = "password";
      }
      this.$nextTick(() => {
        this.$refs.pass.focus();
      });
    },
    // 关闭弹窗时置空表单信息
    entryFormInfo() {
      this.changeSliding(true);
      if (this.$route.name == "workUpload") {
        this.$router.push("/workup/" + this.$route.params.id);
      }
      setTimeout(() => {
        document.getElementsByClassName("header")[0].style.paddingRight = "0";
      }, 200);
      this.$refs["loginValidate"].resetFields();

      // 登录弹窗关闭后发出回调事件
      eventBus.$emit("loginDialogCloseed");
    },

    // 登录
    phoneLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          var data_ = {
            username: this.loginValidate.phone,
            password: this.loginValidate.pass,
            ckey: this.loginValidate.ckey,
            captcha: this.loginValidate.captcha,
          };
          if (this.isCkeyCode) {
            this.getUserInfo(data_);
          } else {
            getIsCode(data_.username)
              .then((res) => {
                if (res.data.is_code == 2) {
                  this.getUserInfo(data_);
                } else {
                  this.updateCkeyCode(1);
                  this.loginLoading = false;
                }
              })
              .catch((err) => {});
          }
        } else {
          this.loginLoading = false;
          return false;
        }
      });
    },
    // 注册
    phoneReg(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.regChecked) {
            this.tipsShow = true;
            setTimeout(() => {
              this.tipsShow = false;
            }, 2000);
            return;
          }
          userRegister(this.register).then((res) => {
            this.changeSliding(true);
            if (this.website.is_register_active) {
              this.$message({
                type: "success",
                message: "注册成功!",
              });
            } else {
              this.$confirm(
                "账号注册成功,但未激活,请联系管理员进行激活!",
                "提示",
                {
                  confirmButtonText: "确定",
                  type: "warning",
                  showCancelButton: false,
                }
              )
                .then(() => {
                  this.loginDialogVisible = false;
                })
                .catch(() => {
                  this.loginDialogVisible = false;
                });
            }
          });
        }
      });
    },
    updateCkeyCode(type) {
      getLoginCkey().then((res) => {
        this.ckeyCode = res.data.img;
        this.loginValidate.ckey = res.data.key;
        if (type) {
          this.isCkeyCode = true;
        }
      });
    },
    // 注册图形验证码
    upRegisterCkeyCode() {
      getLoginCkey().then((res) => {
        this.registerCkeyCode = res.data.img;
        this.register.ckey = res.data.key;
      });
    },
    // 退出登录
    handleLogout() {
      this.$store
        .dispatch("user/logout")
        .then((response) => {})
        .catch((error) => {
          console.log(error);
        });
    },
    async getUserInfo(data_) {
      await this.$store
        .dispatch("user/login", data_)
        .then((response) => {
          if (typeof wf != "undefined") {
            let url = process.env.BASE_API + "/api/destop/login_action";
            console.log("wf=====---:", url, response.user_id);
            wf.setUserId(response.user_id);
            let heads = {
              "bu-id": "course",
              oid: wf.getOrgOid(),
              "device-id": wf.getHWCode(),
              "mac-code": wf.getMacCode(),
            };
            console.log("wf=====---:", url, heads);
            let postData = {
              uid: response.user_id,
            };
            wf.httpRequest(
              url,
              (status, response) => {
                if (response.status === false) {
                  this.handleLogout();
                  this.loginLoading = false;
                  wf.toast(response.error_msg);
                } else {
                  wf.winReload();
                }
              },
              heads,
              postData,
              "post"
            );
          } else {
            this.updateCkeyCode(1);
            location.reload();
          }
        })
        .catch((error) => {
          this.updateCkeyCode(0);
          this.loginValidate.captcha = "";
          this.loginLoading = false;
        });
    },

    // input在focus和blur时校验的处理（focus时，不做校验，异常提示消失；blur时，当value值为空时不做校验，异常提示消失）
    lFocus(_prop) {
      setTimeout(() => {
        this.$refs["loginValidate"].clearValidate([_prop]);
      }, 1);
    },
    lBlur(_refItem, _prop) {
      if (!this.$refs[_refItem].value) {
        this.$nextTick(() => {
          this.$refs["loginValidate"].clearValidate([_prop]);
        });
      }
    },
    // 切换注册
    changeSliding(val) {
      this.isLogin = val;
      if (!val) {
        this.upRegisterCkeyCode();
        this.loginValidate = {
          phone: "",
          pass: "",
          ckey: "",
          captcha: "",
        };
      } else {
        this.register = {
          mobile: "", // 注册手机号码
          name: "", // 注册姓名
          code: "", // 注册手机验证码
          ckey: "",
          captcha: "", // 注册图形验证码
          password: "", // 注册密码
          grade_id: "", // 注册班级id
        };
      }
    },

    // 获取注册手机验证码
    getRegCode() {
      if (!this.register.mobile) {
        this.$message({
          message: "请输入手机号码！",
          type: "warning",
        });
      } else if (!this.register.captcha) {
        this.$message({
          message: "请输入图片验证码！",
          type: "warning",
        });
      } else {
        if (this.codeDisabled) return;
        getLoginCode({
          mobile: this.register.mobile,
          ckey: this.register.ckey,
          captcha: this.register.captcha,
        }).then((res) => {
          this.codeDisabled = true;
          this.codeName = "60s";
          let timerId = setInterval(() => {
            this.CountDown--;
            this.codeName = this.CountDown + "s";
            if (this.CountDown <= 0) {
              clearInterval(timerId);
              this.codeName = "重新发送";
              this.CountDown = 60;
              this.codeDisabled = false;
            }
          }, 1000);
          this.$message({
            type: "success",
            message: "发送成功!",
          });
        });
      }
    },
    // 前往协议
    goPremise(type) {
      if (type) {
        window.open("https://www.yiihuu.com/appapi/include/privacy.php");
      } else {
        window.open("https://www.yiihuu.com/appapi/include/privacy_v2.php");
      }
    },
  },
  computed: {
    ...mapGetters(["website"]),
  },
  mounted: function () {
    getGrades({ limit: 1000 }).then((res) => {
      this.gradesList = res.data.data;
    });
    eventBus.$on("openLoginDialog", (opts) => {
      this.showLoginDialog();
    });
  },
};
</script>
<style lang="scss" scoped>
.ckeyCode {
  cursor: pointer;
}
.eyeicon {
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -7px;
  font-size: 16px;
  cursor: pointer;
}
.activeEye {
  color: #3b8bf6;
}
/deep/ .ckey input {
  padding-right: 145px;
}
.mobile_ckey_box {
  display: flex;
  justify-content: space-between;
  .mobile_ckey {
    width: 64%;
  }
  .mobile_ckey_btn {
    width: 33%;
    color: #606266;
    border: 1px solid #eee;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.2s;
    &:hover {
      color: #409eff;
      border: 1px solid #409eff;
    }
  }
}

.ckeyCodeWrap {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 130px;
  height: 30px;
  // border: 1px solid #333;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
.reg_ckey_code {
  position: absolute;
  right: 5px;
  top: 8px;
  width: 100px;
  height: 30px;
  // border: 1px solid #333;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}
/deep/ .login-dailog {
  color: #333;
  border-radius: 10px;
  margin: 0 !important;
  .el-dialog__header {
    padding: 0;
    .el-dialog__headerbtn {
      z-index: 99;
    }
    .el-dialog__close {
      font-size: 16px;
      font-weight: bold;
      color: #c6c6c6;
    }
    &:hover .el-dialog__close {
      color: #409eff;
    }
    &::after {
      height: 0;
    }
  }
  .el-dialog__body {
    padding: 0 30px 30px;
    .el-input__inner {
      height: 46px;
      line-height: 46px;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-form-item__error {
      top: 105%;
    }
    .password-item {
      margin-bottom: 28px;
    }
    .el-button {
      height: 50px;
      line-height: 50px;
      padding: 0;
      font-size: 16px;
      border-radius: 5px;
      // background: #3b8cf7 linear-gradient(90deg, #3b8cf7 0%, #5a92ff 100%);
      background: #3b8cf7;
      &:hover {
        transition: background-color 0.5s;
        background: #1573f0;
      }
    }
  }
  .title_box {
    height: 50px;
    border-bottom: 2px solid #f5f5f5;
    margin-top: 14px;
    margin-bottom: 28px;
    position: relative;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .sliding {
      width: 75px;
      height: 2px;
      background-color: #409eff;
      border-radius: 2px;
      position: absolute;
      bottom: -3px;
      left: 50px;
      transform: translate(-50%, -50%);
      transition: all 0.3s;
    }
    .l1 {
      left: 25%;
    }
    .l2 {
      left: 75%;
    }
    .mr50 {
      margin-left: 50px;
    }
    .title {
      cursor: pointer;
      font-size: 18px;
    }
  }
  .reg-form {
    .el-form-item__content {
      .el-input {
        .el-input__inner {
          padding-left: 33px !important;
        }
      }
    }

    .register_img {
      width: 25px;
      height: 25px;
    }
    .consent {
      .consent_box {
        font-size: 12px;
        color: #909399;
        .premise {
          color: #409eff;
        }
        &.is-checked + .el-checkbox__label {
          color: #909399;
        }
      }
    }
  }
  .login-form {
    .login-btn {
      width: 100%;
      margin-bottom: 15px;
    }
    .forgot-btn {
      color: #666;
    }
  }
  .reg_tips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 344px;
    height: 56px;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    line-height: 56px;
    color: #fff;
    font-size: 14px;
    letter-spacing: 1px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue